export default Intl.DateTimeFormat('fi-FI');
